// extracted by mini-css-extract-plugin
export default {"cls1":"InviteRegisterYubikey-FormBody_cls1__5P4L1","cls2":"InviteRegisterYubikey-FormBody_cls2__x13-u InviteRegisterYubikey-FormBody_cls1__5P4L1"};